module.exports = "https://i.geely.com//img/geelyAI.12b6a71e.gif";